import {
    PlatformButton,
    PlatformSectionHeading,
    platformContainer,
    platformSection,
} from '../PlatformShared'

export const pricingContainer = platformContainer
export const pricingSection = platformSection

export function PricingHeading(props) {
    return (
        <div className="mb-[38px]">
            <PlatformSectionHeading {...props} align="center" />
        </div>
    )
}
export function PricingButton({ onClick, ...props }) {
    return <PlatformButton {...props} onClick={onClick} />
}
